import axios from "axios";

const PY_BASE =
    process.env.REACT_APP_API_PY_BASE_URL || "https://api-py.mahabharatanubhavkendra.com/";

const trimSlash = (url) => url.replace(/\/+$/, "");

const TOKEN_KEY = 'mbm_access';
const REFRESH_KEY = 'mbm_refresh';

export const authAxios = axios.create({
    baseURL: `${trimSlash(PY_BASE)}/api/`,
});

// Attach Bearer token to every request
authAxios.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// On 401: attempt one token refresh, then retry original request
authAxios.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config;
        if (error.response?.status === 401 && !original._retried) {
            original._retried = true;
            const refresh = localStorage.getItem(REFRESH_KEY);
            if (refresh) {
                try {
                    const { data } = await axios.post(
                        `${trimSlash(PY_BASE)}/api/auth/refresh/`,
                        { refresh }
                    );
                    localStorage.setItem(TOKEN_KEY, data.access);
                    // Store the rotated refresh token if the server returned one
                    if (data.refresh) localStorage.setItem(REFRESH_KEY, data.refresh);
                    original.headers.Authorization = `Bearer ${data.access}`;
                    return authAxios(original);
                } catch {
                    // Refresh failed — clear all tokens and redirect to login
                    localStorage.removeItem(TOKEN_KEY);
                    localStorage.removeItem(REFRESH_KEY);
                    localStorage.removeItem('mbm_user');
                    window.location.href = '/login';
                }
            } else {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
